import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { QuillModule } from 'ngx-quill';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ShareModule} from "./share/share.module";
import {CoreModule} from "./core/core.module";
import {HttpClientModule} from "@angular/common/http";
import Quill from 'quill';
import QuillTableBetter from 'quill-table-better';

Quill.register('modules/table-better', QuillTableBetter, true);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ShareModule,
    CoreModule,
    HttpClientModule,
    QuillModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
